import { useLoaderData, useLocation, useNavigation } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import { usePlentyMediaQuery } from '#app/hooks/use-plenty-media-query'
import { type loader } from '#app/routes/_public+/products+/$slug'
import AppliedFilters from './applied-filters'
import { BrandsDropdown } from './filters/brand-dropdown'
import { ColorsDropdown } from './filters/color-dropdown'
import { GenderDropdown } from './filters/gender-dropdown'
import { MaterialsDropdown } from './filters/materials-dropdown'
import { SizesDropdown } from './filters/size-dropdown'
import { SortingDropdown } from './sort/sorting-dropdown'
import MobileStoreSelector from './store-selector/mobile-store-selector'

const ProductListFilters = () => {
	const { totalCount } = useLoaderData<typeof loader>()
	const navigation = useNavigation()
	const [selectedSortOrder, setSelectedSortOrder] = useState('new')
	const location = useLocation()
	const isKids02 = location.pathname.includes('kids-baby_0_2') ?? false
	const isDesktop = usePlentyMediaQuery('(min-width: 820px)')

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search)
		const sortOrder = searchParams.get('sortingOrder') || 'new'
		setSelectedSortOrder(sortOrder)
	}, [location.search])

	const brandParams = new URLSearchParams(
		navigation.state === 'idle' ? location.search : navigation.location?.search,
	).getAll('brand')

	return (
		<>
			{/* Mobile  */}

			<div className="mt-2 flex flex-col md:mt-0 md:hidden">
				{/* New Filters Labels */}
				<MobileStoreSelector
					totalCount={totalCount}
					brandParams={brandParams}
				/>
			</div>
			{/* Desktop Version */}
			<div className="mt-0 hidden w-full flex-row items-center justify-between md:mt-2 md:flex md:flex-wrap ">
				<ProductCounter totalCount={totalCount} brandParams={brandParams} />

				<div className="flex flex-row flex-wrap gap-y-4 gap-x-4 ">
					<ColorsDropdown />
					<BrandsDropdown />
					<MaterialsDropdown />
					<SizesDropdown />
					{isKids02 && <GenderDropdown />}
					<SortingDropdown selectedSortOrder={selectedSortOrder} />
				</div>
			</div>
			{isDesktop ? <AppliedFilters /> : null}
		</>
	)
}

export default ProductListFilters

const ProductCounter = ({
	totalCount,
	brandParams,
}: {
	totalCount: number
	brandParams: string[]
}) => {
	let { t } = useTranslation('product_list_page')

	return (
		<div className="flex flex-row gap-x-1">
			<PlentyBody size="md" className="font-bold">
				{totalCount}
			</PlentyBody>
			<div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide">
				{brandParams.length ? (
					brandParams.length > 1 ? (
						<PlentyBody size="md">
							{t('products_from_brands', {
								count: brandParams.length,
							})}
						</PlentyBody>
					) : (
						<PlentyBody size="md">
							<span
								dangerouslySetInnerHTML={{
									__html: t('products_from_brand', {
										brand: brandParams[0],
									}),
								}}
							></span>
						</PlentyBody>
					)
				) : (
					<PlentyBody size="md">{t('product_count_text')}</PlentyBody>
				)}
			</div>
		</div>
	)
}
